import { SAMPLE_QUOTE } from './sampleQuote';

export const PASSENGER_DETAILS_COMPLETE_SAMPLE = {
  quote: SAMPLE_QUOTE,
  clientName: 'Jane Doe',
  flights: [
    { departure_airport: 'TEB', arrival_airport: 'MIA', departure_date: '2025-10-24T10:00:00Z' },
    { departure_airport: 'MIA', arrival_airport: 'TEB', departure_date: '2025-10-28T14:00:00Z' },
  ],
  reviewUrl: 'https://app.trustjet.ai/dashboard',
};
